<template>
  <main v-if="isAuthenticated" id="app" class="application">
    <h-shell />
  </main>
  <main v-else-if="isReady" id="app" class="application">
    <h-login />
  </main>
  <div v-else></div>
</template>

<script>
import { mapState } from 'vuex';

import Shell from './components/Shell';
import Login from './components/Login';

export default {
  name: 'App',
  components: {
    'h-shell': Shell,
    'h-login': Login
  },
  computed: {
    ...mapState({
      isReady: s => s.identity.isReady,
      isAuthenticated: s => s.identity.isAuthenticated
    })
  },
  created() {
    this.$store.dispatch('identity/initialize');
  },
  mounted() {
    this.$trackEvent('Pane opened');
  },
  methods: {
    async logout() {
      this.$store.dispatch('identity/logout');
      window.location.reload();
    }
  }
};
</script>

<style lang="scss">
:root {
  // --theme-default: #607d8b;
  // --theme-default-light: rgba(0, 0, 0, 0.12);
  // --theme-default-dark: #455a64;

  --theme-primary: rgb(0, 120, 212);

  --theme-secondary: #fff;

  // #e80a89
  --theme-highlight: rgba(0, 0, 0, 0.05);

  --theme-success: #2e815b;
  --theme-error: #b00020;
  --theme-background: #fff;

  --theme-surface: #fff;
  // --theme-surface: #424242;

  // --theme-on-default: #fff;
  --theme-on-primary: #fff;
  --theme-on-secondary: rgb(50, 49, 48);
  --theme-on-error: #fff;
  --theme-on-success: #fff;

  --theme-on-background: #fff;

  --theme-on-surface: #fff;
}
html,
body {
  margin: 0;
  padding: 0;

  color: rgb(50, 49, 48);
  width: 100%;
  height: 100%;
  overflow: hidden;
}

.application {
  width: 100%;
  height: 100%;
  overflow: hidden;
}

* {
  box-sizing: border-box;
}
</style>
